"use strict";

var _classCallCheck = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var idlUtils = require("../generated/utils");

var createHTMLCollection = require("../../living/html-collection").create;

var childrenByHTMLLocalNames = require("../helpers/traversal").childrenByHTMLLocalNames;

var DOMException = require("../../web-idl/DOMException");

var domSymbolTree = require("../helpers/internal-constants").domSymbolTree;

var closest = require("../helpers/traversal").closest;

var cellLocalNames = new Set(["td", "th"]);

var HTMLTableRowElementImpl = /*#__PURE__*/function (_HTMLElementImpl) {
  _inherits(HTMLTableRowElementImpl, _HTMLElementImpl);

  function HTMLTableRowElementImpl() {
    _classCallCheck(this, HTMLTableRowElementImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(HTMLTableRowElementImpl).apply(this, arguments));
  }

  _createClass(HTMLTableRowElementImpl, [{
    key: "insertCell",
    value: function insertCell(index) {
      var td = this._ownerDocument.createElement("TD");

      var cells = this.cells;

      if (index < -1 || index > cells.length) {
        throw new DOMException(DOMException.INDEX_SIZE_ERR);
      }

      if (index === -1 || index === cells.length) {
        this.appendChild(td);
      } else {
        var ref = idlUtils.implForWrapper(cells[index]);
        this.insertBefore(td, ref);
      }

      return td;
    }
  }, {
    key: "deleteCell",
    value: function deleteCell(index) {
      var cells = this.cells;

      if (index === -1) {
        index = cells.length - 1;
      }

      if (index < 0 || index >= cells.length) {
        throw new DOMException(DOMException.INDEX_SIZE_ERR);
      }

      var td = idlUtils.implForWrapper(cells[index]);
      this.removeChild(td);
    }
  }, {
    key: "cells",
    get: function get() {
      var _this = this;

      if (!this._cells) {
        this._cells = createHTMLCollection(this, function () {
          return childrenByHTMLLocalNames(_this, cellLocalNames);
        });
      }

      return this._cells;
    }
  }, {
    key: "rowIndex",
    get: function get() {
      var table = closest(this, "table");
      return table ? Array.prototype.indexOf.call(table.rows, idlUtils.wrapperForImpl(this)) : -1;
    }
  }, {
    key: "sectionRowIndex",
    get: function get() {
      var parent = domSymbolTree.parent(this);

      if (parent === null) {
        return -1;
      }

      var rows = parent.rows;

      if (!rows) {
        return -1;
      }

      return Array.prototype.indexOf.call(rows, idlUtils.wrapperForImpl(this));
    }
  }]);

  return HTMLTableRowElementImpl;
}(HTMLElementImpl);

module.exports = {
  implementation: HTMLTableRowElementImpl
};